import { BigNumber } from "ethers";
import { ChainId, NetworkInfo, NetworkName } from "./types";

export const FAST_INTERVAL = 10000
export const SLOW_INTERVAL = 60000

export const networkInfo: NetworkInfo[] = [
    { name: NetworkName.BSC, chainId: ChainId.BSC },
    { name: NetworkName.FTM, chainId: ChainId.FTM },
]

export const defaultDecimalPlaces: number = 18 

export const MaxUint256: BigNumber = (/*#__PURE__*/BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"));